module.exports = __webpack_public_path__ + "static/media/bg-6.769dd07c.jpg";